// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const InternalNetworkActionClassSchema = z.enum(['DISCOVERY','CREDENTIAL_VALIDATION','KERBEROAST_DETECTION','ACL_VALIDATION','REMOTE_EXECUTION','PRIVILEGE_ESCALATION','LATERAL_MOVEMENT','PERSISTENCE','CLEANUP'] as const);

export type InternalNetworkActionClassType = `${z.infer<typeof InternalNetworkActionClassSchema>}`

export default InternalNetworkActionClassSchema;
